export const Logo = ({ size = 34, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="32" cy="32" r="29" fill="none" stroke="#C9A24B" strokeWidth="1" opacity=".55" />
    <path d="M32 52V30M32 38l-9-8M32 34l9-9M32 44l-12-5M32 42l12-6" stroke="#C9A24B" strokeWidth="2.2" strokeLinecap="round" fill="none" />
    <circle cx="22" cy="29" r="3.2" fill="#C9A24B" />
    <circle cx="42" cy="24" r="3.2" fill="#C9A24B" />
    <circle cx="19" cy="38" r="2.6" fill="#E4C87F" />
    <circle cx="45" cy="35" r="2.6" fill="#E4C87F" />
    <circle cx="32" cy="20" r="3.8" fill="#C9A24B" />
    <path d="M24 52h16" stroke="#C9A24B" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);
